import React, { Component } from "react"
import { connect } from "react-redux"
import { requestResource } from "home/api_request"
import { BnccExamSessionsTablePresentation } from "home/components/bncc_exam"
import TableWrapper from "home/components/table_wrapper"

class BnccExamSessionsTableContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      tableData: {
        data: null,
        columns: null
      }
    }
  }

  componentDidMount () {
    this.updateData()
  }

  componentDidUpdate (prevProps) {
    if (JSON.stringify(prevProps.filters) != JSON.stringify(this.props.filters)) {
      this.updateData()
    }
  }

  updateData () {
    const { filters } = this.props

    requestResource("bncc_exam/sessions", filters, response => this.setChartConfigFromResponse(response))
  }

  setChartConfigFromResponse (response) {
    this.setState({
      tableData: response.data
    })
  }

  render () {
    return (
      <TableWrapper
        presenter={BnccExamSessionsTablePresentation}
        tableData={this.state.tableData}
        resource={"bncc_exam/sessions"}
        filters={this.props.filters}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    filters: {
      userId: state.filters.userId,
      schoolYear: state.filters.schoolYear,
      schoolClass: state.filters.schoolClass,
      schoolId: state.filters.schoolId,
      "bnccExams/sessions/examId": state.filters["bnccExams/sessions/examId"]
    }
  }
}

export default connect(mapStateToProps)(BnccExamSessionsTableContainer)
